import { gql } from "@apollo/client";

// import { UserComboboxUserOptionFragment } from "@components/people-dropdown/get-user-combobox-options-query";

import { MeetingsOverviewMeeting } from "./meetings-overview-meeting-fragment";

export default gql`
  ${MeetingsOverviewMeeting}
  query getUnscheduledMeetingsQuery(
    $forUserId: Int!
    $selectedUserId: Int!
    $hasSelectedUserId: Boolean!
  ) {
    unscheduledMeetings: calendar(
      forUserId: $forUserId
      unscheduled: true
      isFinalized: false
    ) {
      totalCount
      edges {
        node {
          id
          meeting {
            ...MeetingsOverviewMeeting
          }
        }
      }
    }
    user(userId: $selectedUserId) @include(if: $hasSelectedUserId) {
      id
      id
      name
      firstName
      email
      avatar
    }
  }
`;
